import * as React from 'react';
import AppTabs from '../../../components/AppTabs';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { SettingsItemContentProps } from '../SettingsItem';
import { RemindersSettingsData } from '../../../models';
import { useDispatch, useSelector } from 'react-redux';
import { Tabs, Tab } from '@material-ui/core';
import { getCommunicationQuotas } from '../../../store/general/selectors';
import { loadCommunicationQuotasIfNeeded } from '../../../store/general/actions';
import ClientRemindersTab from './ClientRemindersTab';
import FollowUpTab from './FollowUpTab';
import ConfirmationTab from './ConfirmationTab';
import BirthdayMessageTab from './BirthdayMessageTab';

export {
    normalizeReminderServiceTypesKeys,
    shouldShowNoServiceTypesWarning,
    normalizeEmailReminderSettings,
    normalizeClientsFollowUpSettings,
} from './remindersShared';

export interface RemindersSettingsProps extends SettingsItemContentProps {
    values: RemindersSettingsData,
    onChange: (settings: RemindersSettingsData) => void
}

const RemindersSettings: React.FC<RemindersSettingsProps> = (props) => {
    const {
        values,
        onChange,
    } = props;

    const t = useTranslations();
    const [tab, setTab] = React.useState<'client' | 'follow-up' | 'confirmation' | 'birthday'>('client');
    const communicationQuotas = useSelector(getCommunicationQuotas) ?? null;
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadCommunicationQuotasIfNeeded());
    }, [dispatch]);

    return (
        <div>

            <AppTabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary" style={{marginBottom: 'var(--spacer-S)', borderBottom: 'var(--border-thin) solid var(--appLigthGrey)'}}>
                <Tab label={t(TK.clientReminders)} value="client" />
                <Tab label={t(TK.automaticFollowUp)} value="follow-up" />
                <Tab label={t(TK.appointmentConfirmationRequest)} value="confirmation" />
                <Tab label={t(TK.birthdayMessage)} value="birthday" />
            </AppTabs>

            <div>
                {/* Client Reminders Tab */}
                {tab === 'client' && <ClientRemindersTab
                    values={values}
                    onChange={onChange}
                    communicationQuotas={communicationQuotas}
                />}

                {/* Automatic Follow-Up Tab */}
                {tab === 'follow-up' && <FollowUpTab
                    values={values}
                    onChange={onChange}
                    communicationQuotas={communicationQuotas}
                />}

                {/* Appointments Confirmation Tab */}
                {tab === 'confirmation' && <ConfirmationTab
                    values={values}
                    onChange={onChange}
                    communicationQuotas={communicationQuotas}
                />}

                {/* Birthday Message Tab */}
                {tab === 'birthday' && <BirthdayMessageTab
                    values={values}
                    onChange={onChange}
                    communicationQuotas={communicationQuotas}
                />}
            </div>
        </div>
    );
}

export default RemindersSettings;
